type TTooltipValueExtractor = (item: any) => any;

/**
 * Extract the raw value used to determine whether a tooltip row has data.
 * Supports common ECharts payload shapes used across strategic charts.
 */
export const getTooltipRawValue: TTooltipValueExtractor = (item: any) => {
  const raw = item?.data?.tooltipValue ?? item?.data?.value ?? item?.value;
  if (raw && typeof raw === 'object' && 'value' in raw) {
    return raw.value;
  }
  return raw;
};

/**
 * Returns true when all tooltip series values are effectively empty.
 */
export const isTooltipAllSeriesEmpty = (
  params: any[] | any,
  valueExtractor: TTooltipValueExtractor = getTooltipRawValue,
): boolean => {
  const paramsList = Array.isArray(params) ? params : [params];
  return paramsList.every((item: any) => {
    const rawValue = valueExtractor(item);
    return rawValue === null
      || rawValue === undefined
      || (typeof rawValue === 'number' && Number.isNaN(rawValue));
  });
};

/**
 * Wrap an existing tooltip formatter with an empty-data guard.
 * If every series at hover point is empty, returns an empty string to hide tooltip.
 */
export const withTooltipEmptyGuard = (
  formatter: (params: any[]) => string,
  valueExtractor: TTooltipValueExtractor = getTooltipRawValue,
) => {
  return (params: any[]): string => {
    if (isTooltipAllSeriesEmpty(params, valueExtractor)) {
      return '';
    }
    return formatter(params);
  };
};
